import React, { useState } from 'react'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'

import { intCol, strCol } from '@integec/grid-tools/lib/cols'
import {
  deleteSolarCauseCode,
  getSolarCauseCode,
  updateSolarCauseCode,
} from 'api/pgads'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input, InputNumber } from 'antd'

const title = 'Solar Cause Code'

const SolarCausecode = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const InsertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '180px 200px 90px 200px 90px 200px auto auto auto',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>System :</Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Input
          value={insertData.system}
          placeholder="System"
          onChange={e =>
            setInsertData({
              ...insertData,
              system: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Sub System :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Input
          value={insertData.subsystem}
          placeholder="Sub System"
          onChange={e =>
            setInsertData({
              ...insertData,
              subsystem: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Cause Code :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <InputNumber
          value={insertData.causecode}
          className="causeCode"
          onChange={causecode =>
            setInsertData({
              ...insertData,
              causecode,
            })
          }
        />
        <div style={{ gridColumnEnd: 'span 3' }} />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Cause Code Description :
          </Label>
        </div>
        <Input
          style={{ gridColumnEnd: 'span 4' }}
          placeholder="Cause Code Description"
          value={insertData.description}
          onChange={e =>
            setInsertData({
              ...insertData,
              description: e.target.value,
            })
          }
        />

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: 5,
            gridColumnStart: '6',
            // gridColumnEnd: 'span 2',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={Wind2CausecodeHeaders}
      saveTask={updateSolarCauseCode}
      retrieveTask={getSolarCauseCode}
      deleteTask={deleteSolarCauseCode}
      autoRetrieve
      // widthOffset={50}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
      headerRowHeight={30}
      sortOptions={Wind2CausecodeHeaders}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SolarCausecode)

const Wind2CausecodeHeaders = [
  strCol({
    ident: 'system',
    display: 'System',
    isKey: true,
    width: 250,
    // ellipsis: true,
    // alignment: 'left',
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'subsystem',
    display: 'Sub System',
    isKey: true,
    sortOrder: 'asc',
    width: 250,
  }),
  intCol({
    ident: 'causecode',
    display: 'Cause Code',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'description',
    display: 'Cause Code Description',
    isFiltered: true,
    width: 700,
    ellipsis: true,
    alignment: 'left',
  }),
  modifierCol,
  modifiedDateCol,
]
